import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Trash = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 3.5H3M14.5 3.5H13M3 3.5L3.5 14H12L13 3.5M3 3.5H5.5M13 3.5H10.5M5.5 3.5C5.5 2.83333 6 1.5 8 1.5C10 1.5 10.5 2.83333 10.5 3.5M5.5 3.5H10.5"
        stroke={color}
      />
    </svg>
  ),
)

Trash.displayName = 'Trash'

Trash.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Trash
